import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

/**
 * Note: sub-menu only appear when route children.length >= 1
 * Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor']    control the page roles (you can set multiple roles)
    title: 'title'               the name show in sidebar and breadcrumb (recommend set)
    icon: 'svg-name'/'el-icon-x' the icon show in the sidebar
    breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
    activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
  }
 */

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
export const constantRoutes = [
  {
    path: "/",
    component: () => import("@/views/index"),
    hidden: true,
  },
  {
    path: "/vehicleWork",
    component: () => import("@/views/vehicleWork"),
    hidden: true,
  },
  {
    path: "/vehicleWorkDetail",
    component: () => import("@/views/vehicleWorkDetail"),
    hidden: true,
  },
  {
    path: "/vehicleLocation",
    component: () => import("@/views/vehicleLocation"),
    hidden: true,
  },
  {
    path: "/vehicleReceiving",
    component: () => import("@/views/vehicleReceiving"),
    hidden: true,
  },
  {
    path: "/fieldForm",
    component: () => import("@/views/fieldForm"),
    hidden: true,
  },
  {
    path: "/orderTake",
    component: () => import("@/views/orderTake"),
    hidden: true,
  },
  {
    path: "/orderTakeDetail",
    component: () => import("@/views/orderTakeDetail"),
    hidden: true,
  },
  {
    path: "/vehicleApply",
    component: () => import("@/views/vehicleApply"),
    hidden: true,
  },
  {
    path: "/addVehicleApply",
    component: () => import("@/views/addVehicleApply"),
    hidden: true,
  },
  {
    path: "/vehicleApplyDetail",
    component: () => import("@/views/vehicleApplyDetail"),
    hidden: true,
  },
  {
    path: "/dispatch",
    component: () => import("@/views/dispatch"),
    hidden: true,
  },
  {
    path: "/addDispatch",
    component: () => import("@/views/addDispatch"),
    hidden: true,
  },
  {
    path: "/history",
    component: () => import("@/views/history"),
    hidden: true,
  },
  {
    path: "/vehicleApproval",
    component: () => import("@/views/vehicleApproval"),
    hidden: true,
  },
  {
    path: "/diaodu",
    component: () => import("@/views/diaodu"),
    hidden: true,
  },
  {
    path: "/vehicleLocate",
    component: () => import("@/views/vehicleLocate"),
    hidden: true,
  },
  {
    path: "/vehicleTrack",
    component: () => import("@/views/vehicleTrack"),
    hidden: true,
  },
  {
    path: "/track",
    component: () => import("@/views/track"),
    hidden: true,
  },
  {
    path: "/login",
    component: () => import("@/views/login"),
    hidden: true,
  },
  {
    path: "/my",
    component: () => import("@/views/my"),
    hidden: true,
  },
  {
    path: "/mycenter",
    component: () => import("@/views/mycenter"),
    hidden: true,
  },
  {
    path: "/resetPw",
    component: () => import("@/views/resetPw"),
    hidden: true,
  },
  {
    path: "/useCarOrder",
    component: () => import("@/views/useCarOrder"),
    hidden: true,
  },
  {
    path: "/useCarOrderDetail",
    component: () => import("@/views/useCarOrderDetail"),
    hidden: true,
  },
  // 404 page must be placed at the end !!!
  { path: "*", redirect: "/", hidden: true },
];

const router = new Router({
  // mode: 'history', // require service support
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes,
});

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
// export function resetRouter() {
//   const newRouter = createRouter();
//   router.matcher = newRouter.matcher; // reset router
//   return newRouter;
// }

export default router;
